<template>
  <div>
    <a-modal
      v-model="visible"
      :title="title"
      :destroyOnClose="true"
      :width="800"
    >
      <a-spin :spinning="isLoading">
        <a-form-model
          ref="InstanceAppSettingsForm"
          :model="instanceAppSetting"
          :rules="rules"
          layout="vertical"
          autocomplete="off"
        >
          <a-row :gutter="16">
            <a-col :span="12">
              <a-form-model-item label="Business" prop="businessId">
                <a-select
                  placeholder="Business"
                  v-model="instanceAppSetting.businessId"
                  style="width: 100%"
                >
                  <a-select-option
                    v-for="business in businesses"
                    :key="business.id"
                    :value="business.id"
                  >
                    {{ business.name }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="12">
              <a-form-model-item label="App Setting Key" prop="appSettingKey">
                <a-input
                  autocomplete="off"
                  placeholder="App Setting Key"
                  v-model="instanceAppSetting.appSettingKey"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="20">
              <a-form-model-item
                label="App Setting Value"
                prop="appSettingValue"
              >
                <a-input
                  :type="inputType"
                  placeholder="App Setting Value"
                  :disabled = "instanceAppSetting.isSensetive"
                  v-model="instanceAppSetting.appSettingValue"
                />
              </a-form-model-item>
            </a-col>
            <a-col :span="4">
              <a-form-model-item label="Is Sensetive" prop="isSensetive">
                <a-switch
                  default-unchecked
                  @change="onChangeIsSensetive"
                  v-model="instanceAppSetting.isSensetive"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-spin>
      <template #footer>
        <a-button type="primary" @click="save" :loading="isSaving"
          >Save</a-button
        >
        <a-button @click="cancel">Cancel</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import ModalMixin from "../Common/Mixins/modalMixin";
import { instanceAppSettingsMutations } from "../../Store/store";

export default {
  props: {
    instanceAppSetting: {
      type: Object,
      default: () => ({}),
    },
    businesses: { type: Array, default: () => [] },
  },
  mixins: [ModalMixin],
  data() {
    return {
      rules: {
        appSettingKey: [
          {
            required: true,
            message: "Please input a app Setting Key!",
            trigger: "blur",
          },
        ],
        businessId: [
          { required: true, message: "Business is required!", trigger: "blur" },
        ],
        appSettingValue: [
          {
            required: true,
            message: "Please input a app Setting Value!",
            trigger: "blur",
          },
        ],
      },
      isSaving: false,
      tempAppSettingValue: "who knows security?",
      isLoading: false,
    };
  },
  computed: {
    addInstanceAppSettingsSuccess() {
      return `Instance AppSettings ${
        this.mode == this.modes.edit ? "updated" : "added"
      } successfully!`;
    },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.tempAppSettingValue = this.getDefaultPassword;
        this.$emit("input", val);
      },
    },
    getDefaultPassword() {
      return "who knows security?";
    },
    inputType: {
      get() {
        return this.instanceAppSetting.isSensetive ? "password" : "text";
      },
    },
  },
  methods: {
    save() {
      this.$refs.InstanceAppSettingsForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;
          try {
            this.instanceAppSetting.appSettingValue =
              this.instanceAppSetting.appSettingValue == this.getDefaultPassword
                ? this.tempAppSettingValue
                : this.instanceAppSetting.appSettingValue;
            if (this.mode == this.modes.edit) {
              await instanceAppSettingsMutations.updateInstanceAppSetting(
                this.instanceAppSetting
              );
            } else {
              await instanceAppSettingsMutations.addInstanceAppSetting(
                this.instanceAppSetting
              );
            }
            this.$message.success(this.addInstanceAppSettingsSuccess);
            this.visible = false;
          } catch (error) {
            this.showError(error);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
    async onChangeIsSensetive(value) {
      if (
        !value &&
        this.mode == this.modes.edit &&
        this.tempAppSettingValue == this.getDefaultPassword
      ) {
        this.isLoading = true;
        var response = await instanceAppSettingsMutations.getDecryptedValue(
          this.instanceAppSetting.id
        );
        this.isLoading = false;
        if (response.status == 200) {
          this.instanceAppSetting.appSettingValue = response.data.result;
        }
      } else if (value) {
        if (this.instanceAppSetting.appSettingValue) {
          this.tempAppSettingValue = this.instanceAppSetting.appSettingValue;
          this.instanceAppSetting.appSettingValue = this.getDefaultPassword;
        }
      } else {
        if (this.instanceAppSetting.appSettingValue)
          this.instanceAppSetting.appSettingValue = this.tempAppSettingValue;
      }
    },
    cancel() {
      this.tempAppSettingValue = this.getDefaultPassword;
      this.visible = false;
    },
  },
};
</script>